// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3dygv","range":"MonthRangeSwitch_range__spTFN","disabled":"MonthRangeSwitch_disabled__30wpF"};